import {NodeTypes} from "@xyflow/react";
import WorkflowNode from "./FlowNode";
import BranchNode from "./BranchNode";
import {FlowNodesData} from "./NodesData";
import {FlowNodeTypes} from "@/types/node";

export const createNodeTypes = (showContext: boolean): NodeTypes => {
  return Object.keys(FlowNodesData).reduce((acc, key) => {
    switch (key) {
      case FlowNodeTypes.BRANCH:
        acc[key] = props => <BranchNode {...props} showContext={showContext} />;
        break;
      default:
        acc[key] = props => (
          <WorkflowNode {...props} showContext={showContext} />
        );
    }
    return acc;
  }, {} as NodeTypes);
};
